
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/cv/[slug]",
      function () {
        return require("private-next-pages/[locale]/cv/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/cv/[slug]"])
      });
    }
  